<template>
  <div>
    <b-navbar toggleable="lg" fixed="top" variant="transparent" class="justify-content-between">
      <b-nav>
        <router-link :to="{name: 'home'}"><b-button variant="light">ย้อนกลับ</b-button></router-link>
      </b-nav>
    </b-navbar>
</div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
